import { useEffect, useState } from "react";

/** The current time in milliseconds, renewed every `everyMs`: re-renders a relative time ("4 minutes ago"). */
export function useNow(everyMs = 60_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), everyMs);
    return () => clearInterval(timer);
  }, [everyMs]);
  return now;
}
